const initState = {
  sessionData: [],
  isAthleteFavourite: false,
  sportType: "",
  athleteData: {},
  isPayout: [],
  sessionalBy: [],
  lastFavouriteDocument: null,
  hasMoreFavouriteDocuments: true,
  lastDocument: null,
  hasMoreDocuments: true,
  hasMoreSeasonal: true,
  seasonalData: {},
  lastSeasonal: "",
  AllSeasonalData: [],
  AllSeasonal: [],
  seasonalFavourites: [],
  AllAthleteSeasonal: [],
  seasonalLastDocument: "",
  hasMoreAthleteSeasonal: true,
  getBadge: null,
  AthleteBadges: [],
  favorite: [],
  favoriteLastDocument: [],
  favouriteHasMoreDocument: false,
  urlSeasonalData: {},
};
const seasonalReducer = (state = initState, action) => {
  switch (action.type) {
    case "URL_SEASONAL_DATA":
      return {
        ...state,
        urlSeasonalData: action.payload,
      };
    case "REMOVE_FAVORITE":
      let deleteFavorite = state.favorite.filter(
        (items) => items.docId !== action.payload
      );
      return {
        ...state,
        favorite: deleteFavorite,
      };
    case "UPDATE_FAVORITE":
      let update = state.favorite.map((items) =>
        items.docId == action.payload.id
          ? { ...items, [action.payload.type]: action.payload.value }
          : items
      );
      return {
        ...state,
        favorite: update,
      };
    case "GET_FAVORITE":
      return {
        ...state,
        favorite: action.payload.data,
        favoriteLastDocument: action.payload.lastDocument,
        favouriteHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "GET_FAVORITE_LOADMORE":
      return {
        ...state,
        favorite: [...state.favorite, ...action.payload.data],
        favoriteLastDocument: action.payload.lastDocument,
        favouriteHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "ALL-ATHLETE-SEASONAL-EMPTY":
      return {
        ...state,
        AllAthleteSeasonal: action.payload.data,
        seasonalLastDocument: action.payload.lastDocument,
        hasMoreAthleteSeasonal: action.payload.hasMoreDocument,
      };
    case "ALL-ATHLETE-SEASONAL":
      return {
        ...state,
        AllAthleteSeasonal: [
          ...state.AllAthleteSeasonal,
          ...action.payload.data,
        ],
        seasonalLastDocument: action.payload.lastDocument,
        hasMoreAthleteSeasonal: action.payload.hasMoreDocument,
      };
    case "IS_ATHLETE_FAVOUTITES":
      return {
        ...state,
        isAthleteFavourite: action.payload,
      };
    case "GET_SEASONAL":
      return {
        ...state,
        sessionData: [...state.sessionData, ...action.payload.data],
        sportType: action.payload.sportType,
        athleteData: action.payload.athleteData,
        lastDocument: action.payload.lastDocument,
        hasMoreDocuments: action.payload.hasMoreDocument,
      };
    case "GET_SEASONAL_START":
      return {
        ...state,
        sessionData: action.payload.data,
        sportType: action.payload.sportType,
        athleteData: action.payload.athleteData,
        lastDocument: action.payload.lastDocument,
      };
    case "GET_SEASONAL_NULL":
      return {
        ...state,
        hasMoreDocuments: action.payload.hasMoreDocument,
      };
    case "GET_SEASONAL_EMPTY":
      return {
        ...state,
        sessionData: action.payload.data,
        sportType: action.payload.sportType,
        athleteData: action.payload.athleteData,
        lastDocument: action.payload.lastDocument,
        hasMoreDocuments: action.payload.hasMoreDocument,
      };
    case "GET_SEASONAL_BY_ID":
      return {
        ...state,
        sessionalBy: action.payload.data,
        seasonalData: action.payload.temp_data,
        lastSeasonal: action.payload.lastDocument,
        hasMoreSeasonal: action.payload.hasMoreDocuments,
      };
    case "GET_IS_PAYOUT_SEASONAL":
      return {
        ...state,
        isPayout: action.payload,
      };
    case "GET_BADGE_BY_ID":
      return {
        ...state,
        getBadge: action.payload,
      };
    case "GET_BADGES_BY_ATHLETE_ID":
      return {
        ...state,
        AthleteBadges: action.payload,
      };
    case "GET_ALL_SEASONAL_BADGES_BY_ATHLETE_ID":
      return {
        ...state,
        AllSeasonal: action.payload,
      };
    case "GET_ALL_SEASONAL_BADGES":
      return {
        ...state,
        AllSeasonal: action.payload.data,
        AllSeasonalData: action.payload.temp_data,
        lastSeasonal: action.payload.lastDocument,
        hasMoreSeasonal: action.payload.hasMoreDocuments,
      };

    case "add_seasonal_Favourites":
      const isDuplicate = state.seasonalFavourites.some(
        (fav) =>
          fav.athlete_id === action.payload.athlete_id &&
          fav.fan_id === action.payload.fan_id
      );

      if (isDuplicate) {
        return state;
      }

      return {
        ...state,
        seasonalFavourites: [...state.seasonalFavourites, action.payload],
      };

    case "get_seasonal_Favourites":
      return {
        ...state,
        seasonalFavourites: action.payload,
      };
    case "remove_seasonal_Favourite":
      return {
        ...state,
        seasonalFavourites: state.seasonalFavourites.filter(
          (fav) =>
            fav.athlete_id !== action.payload.athleteId ||
            fav.fan_id !== action.payload.fanId
        ),
      };
    case "GET_SEASONAL_BY_BTN_LOADER":
      let sessionalData = [...state.sessionalBy];
      let upDataSessional = sessionalData.map((item) => {
        if (item.athlete.athleteID == action.payload.athleteId) {
          let yearlyData = item.data.map((e) => {
            if (e.year == action.payload.year) {
              let yearlyData = e.yearlyData.map((el) => {
                if (el.docId == action.payload.docId) {
                  return {
                    ...el,
                    btnLoader: action.payload.btnLoader,
                  };
                }
                return el;
              });
              return {
                ...e,
                yearlyData: yearlyData,
              };
            }
            return e;
          });
          return {
            ...item,
            data: yearlyData,
          };
        }
        return item;
      });
      return {
        ...state,
        sessionalBy: upDataSessional,
      };
    default:
      return {
        ...state,
      };
  }
};
export default seasonalReducer;
